import React, {useState, useEffect} from 'react';
import PropTypes from "prop-types";
import {navigateWithParams, formatDate} from "../includes/utils";
import {
  CsfPivotalFournisseurDeleteModal
} from "../includes/csf-fournisseur-delete-modal";
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import {
  startLoadingSpinner,
  stopLoadingSpinner
} from "../../csf-ufc-pivotal/includes/utils";

export function CsfPivotalFournisseurRecognitionLastRequest({
                                                              formDetail,
                                                              urlRequestRecognition,
                                                              formLastRequest,
                                                              accessToken,
                                                              apiUrl,
                                                              apiEnv,
                                                              urlList
                                                            }) {

  const language = document.documentElement.lang;
  const [splitStatusActivity, setSplitStatusActivity] = useState([]);

  /*
  * Method that handle de click on button to go to the activity form.
  * */
  function onClickActivity(renewal) {
    const urlParams = {
      activity: formDetail.REDU_Activity_Id,
    };
    if (renewal === true) {
      urlParams.renewal = true;
    }
    navigateWithParams(urlRequestRecognition, urlParams);
  }

  /*
* Method that handle de delete button on the modal and delete a delegation
* */
  function handleDeleteRecognitionDraftModal() {

    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);

    let deleteRequestData = {
      form: 'CSF_EP_Recognition_Cancel',
      recordId: formDetail.Recognition_Id,
      deltaData: {
        Status_Recognition_Id: 'AAAAAAAAAB8='
      }
    };

    startLoadingSpinner();
    pivotalFormApi.callFormPutEndpoint(deleteRequestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success) {
          stopLoadingSpinner();
          console.log("%c Delete successful", 'background: #5E5E5E; color: #0f0');
          // redirect to the list of activities
          location.href = urlList;
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  function handleCancelModal() {
    // no action required: we have a single delete action in this page.
  }

  /*
  * Effect that used to split the activity status label if necessary and get the right language label.
  * */
  useEffect(() => {
    if (formLastRequest && formLastRequest?.REDU_Status_Activity_Id) {
      if ((formLastRequest?.REDU_Status_Activity_Id === "AAAAAAAAACs=" || formLastRequest?.REDU_Status_Activity_Id === "AAAAAAAAABo=")) {
        let parts = formLastRequest.Name_English.split(" - ");
        if (language === 'fr') {
          parts = formLastRequest.Name_French.split(" - ");
        }
        setSplitStatusActivity(parts);
      } else {
        const text = language === 'fr' ? formLastRequest.Name_French : formLastRequest.Name_English;
        setSplitStatusActivity(text);
      }
    }
  }, [formLastRequest]);

  return (
    <div className="primary recognition-last-request">
      <h2>{window.Drupal.t('fournisseur.recognition.detail.last.request.title')}</h2>

      <div className="inner-wrapper">
        <h3 className="recognition-title">
          <span>#{formLastRequest.NoReconnaissance} -</span>
          <span>
            {Array.isArray(splitStatusActivity) && splitStatusActivity.length === 2 ? (
              ' ' + splitStatusActivity[1]
            ) : typeof splitStatusActivity === 'string' ? (
              ' ' + splitStatusActivity
            ) : null}
          </span>
        </h3>
        <div className="d-flex align-items-center">
          <div className="recognition-status">
            {formLastRequest.Flag === 1 ? (
              <img src="/themes/custom/tink/dist/assets/icn-warning.svg" data-toggle="tooltip"
                   title={formLastRequest.Flag__Choice} alt="Tooltip icon"/>
            ) : formLastRequest.Flag === 2 ? (
              <img src="/themes/custom/tink/dist/assets/icn-error.svg" data-toggle="tooltip"
                   title={formLastRequest.Flag__Choice} alt="Tooltip icon"/>
            ) : ""}
          </div>
          <div className="recognition-info">
            {Array.isArray(splitStatusActivity) && splitStatusActivity.length === 2 && (
              <span className="recognition-info-title">{splitStatusActivity[0]}</span>
            )}
            {formLastRequest.EP_LastEditDate && (
              <span className="recognition-info-dates"
                    dangerouslySetInnerHTML={{__html: window.Drupal.t('fournisseur.last.modification.date.html') + ' ' + formatDate(formLastRequest.EP_LastEditDate)}}></span>
            )}
            {formLastRequest.Flag !== 1 && formLastRequest.Flag !== 2 && (
              <span>
                {window.Drupal.t('fournisseur.detail.recognition.date') + ' '}
                {formLastRequest.Start_Date && (
                  <>
                    {formatDate(formLastRequest.Start_Date, '2-digit')}
                    {formLastRequest.End_Date && (
                      <> - {formatDate(formLastRequest.End_Date, '2-digit')}</>
                    )}
                  </>
                )}
              </span>
            )}
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between pt-4">
          {formLastRequest.Flag === 1 || formLastRequest.Flag === 2 ? (
            <>
              <button className="button btn-larger" type="button" onClick={() => onClickActivity(false)}>
                {window.Drupal.t('fournisseur.recognition.detail.last.request.complete')}
              </button>
              <button className="button btn-larger btn-outlined"
                      type="button"
                      data-toggle="modal"
                      data-target="#deleteModal"
              >
                {window.Drupal.t('Cancel')}
              </button>

              <CsfPivotalFournisseurDeleteModal
                deleteType={'deleteRecognitionDraft'}
                handleDeleteModal={handleDeleteRecognitionDraftModal}
                handleCancelModal={handleCancelModal}
              />
            </>
          ) : (
            <div className="buttons-wrapper flex-wrap justify-content-center">
              <button className="button btn-outlined" type="button" data-toggle="modal" data-target="#eventModificationModal">
                Modification
              </button>
              { formLastRequest?.REDU_Status_Activity_Id !== "AAAAAAAAABM=" && ( // Pas "02 - En analyse"
                <button className="button btn-outlined" onClick={() => onClickActivity(true)} type="button">
                  {window.Drupal.t('fournisseur.last.modification.btn.renewal')}
                </button>
              )}
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurRecognitionLastRequest.propTypes = {
  formDetail: PropTypes.object,
  urlRequestRecognition: PropTypes.string,
  formLastRequest: PropTypes.object,
  accessToken: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  apiEnv: PropTypes.string.isRequired,
  urlList: PropTypes.string.isRequired
};
